<div *ngIf="!user.canManageAdvanced()" class="alert alert-light border small mb-3 py-2 px-3">
  <i class="fas fa-info-circle me-2 text-muted"></i>
  Analytics Settings are read-only for your role. Only Managers can change these values.
</div>

<div class="row">
  <div class="col-12 col-lg-3">
    <div class="card bg-white">
      <h4 class="card-header bg-white d-flex align-items-center min-height">
        Analytics Settings
      </h4>
      <div class="list-group list-group-flush">
        <a [routerLink]="['/tenders', tenderId, 'analytics-settings', 'cost-of-capital']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" class="list-group-item list-group-item-action">
          WACC
        </a>
        <!-- Removed till the IATA XML is implemented
                <a [routerLink]="['/tenders', tenderId, 'analytics-settings', 'payment-terms']"
                    routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  class="list-group-item list-group-item-action">
                    Preferred Payment Terms
                </a> -->
        <a [routerLink]="['/tenders', tenderId, 'analytics-settings', 'conversion-factors']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" class="list-group-item list-group-item-action">
          Conversion Factors (Currency & Units)
        </a>

        <a [routerLink]="['/tenders', tenderId, 'analytics-settings', 'tender-current-contract']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" class="list-group-item list-group-item-action">
          Select Current Contract for Comparison
        </a>
        <!-- <a [routerLink]="['/tenders', tenderId, 'analytics-settings', 'input-current-contract']"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="list-group-item list-group-item-action">
          Current Contracts
        </a> -->
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-9 mb-3">
    <div class="card bg-white">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
